export default __webpack_public_path__ + "static/media/react-redux-flow.e1cd6822.png";